import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

const staticRangeHandler = {
    range: {},
    isSelected (range) {
        const definedRange = this.range();
        return (
            dayjs(range.startDate).isSame(dayjs(definedRange.startDate), "day") &&
        dayjs(range.endDate).isSame(dayjs(definedRange.endDate), "day")
        );
    }
};
  
export function createStaticRanges (ranges) {
    return ranges.map((range) => ({ ...staticRangeHandler, ...range }));
}

export const defaultStaticRanges = () => {
    const defined = {
        startOfWeek     : new Date(dayjs().startOf("week")),
        endOfWeek       : new Date(dayjs().endOf("week")),
        startOfToday    : new Date(dayjs().startOf("today")),
        endOfToday      : new Date(dayjs().endOf("today")),
        startOfYesterday: new Date(dayjs().add(-1, "day").startOf("today")),
        endOfYesterday  : new Date(dayjs().add(-1, "day").endOf("today")),
        startOfMonth    : new Date(dayjs().startOf("month")),
        endOfMonth      : new Date(dayjs().endOf("month")),
        startOfLastMonth: new Date(dayjs().add(-1, "month").startOf("month")),
        endOfLastMonth  : new Date(dayjs().add(-1, "month").endOf("month")),
        endOfThirtyDay  : new Date(dayjs().subtract(29, "day").startOf("today")),
        endOfSeventhDay : new Date(dayjs().subtract(6, "day").endOf("today"))
    };
    const handleDiffDays = () => {
        return false;
    };
    const { t } = useTranslation();
    return createStaticRanges([
        {
            label: <div data-cy="today">{t("Today")}</div>,
            range: () => ({
                startDate: defined.startOfToday,
                endDate  : defined.endOfToday
            }),
            omit: handleDiffDays(defined.startOfToday, defined.endOfToday)
        },
        {
            label: <div data-cy="yesterday">{t("Yesterday")}</div>,
            range: () => ({
                startDate: defined.startOfYesterday,
                endDate  : defined.endOfYesterday
            }),
            omit: handleDiffDays(defined.startOfYesterday, defined.endOfYesterday)
        },
        {
            label: <div data-cy="week">{t("This Week")}</div>,
            range: () => ({
                startDate: defined.startOfWeek,
                endDate  : defined.startOfToday
            }),
            omit: handleDiffDays(defined.startOfToday, defined.startOfWeek)
        },
        {
            label: <div data-cy="last-7-days">{t("Last 7 Days")}</div>,
            range: () => ({
                startDate: defined.endOfSeventhDay,
                endDate  : defined.startOfToday
            }),
            omit: handleDiffDays(defined.startOfToday, defined.endOfSeventhDay)
        },
        {
            label: <div data-cy="this-month">{t("This Month")}</div>,
            range: () => ({
                startDate: defined.startOfMonth,
                endDate  : defined.startOfToday
            }),
            omit: handleDiffDays(defined.startOfToday, defined.startOfMonth)
        },
        {
            label: <div data-cy="last-month">{t("Last Month")}</div>,
            range: () => ({
                startDate: defined.startOfLastMonth,
                endDate  : defined.endOfLastMonth
            }),
            omit: handleDiffDays(defined.endOfLastMonth, defined.startOfLastMonth)
        },
        {
            label: <div data-cy="last-30-days">{t("Last 30 Days")}</div>,
            range: () => ({
                startDate: defined.endOfThirtyDay,
                endDate  : defined.startOfToday
            }),
            omit: handleDiffDays(defined.startOfToday, defined.endOfThirtyDay)
        }
    ]);
};
 